import { FIELD_RESPONSE_CODES, FIELD_RESPONSE_MODES } from "./checklistInputFields";

export function persistedChecklistTypeItemId(value) {
  if (value == null || value === "") return null;
  const asString = String(value);
  if (asString === "0") return null;
  if (/^id/i.test(asString) || asString.startsWith("drag")) return null;
  const asNumber = Number(value);
  if (Number.isInteger(asNumber) && asNumber > 0) return asNumber;
  return null;
}

export function serializeChecklistTypeInputField(field) {
  if (!field || typeof field !== "object") return null;
  const label = String(field.label || "").trim();
  if (!label) return null;

  const out = {
    label,
    input_type: field.input_type || "text",
    required: Boolean(field.required),
  };
  if (field.key) out.key = field.key;
  const fieldId = field.id;
  if (fieldId != null && String(fieldId).trim() !== "") {
    out.id = fieldId;
  }
  if (field.unit) out.unit = String(field.unit).trim();
  if (field.placeholder) out.placeholder = String(field.placeholder).trim();
  const rules = Object.fromEntries(FIELD_RESPONSE_CODES
    .filter((code) => FIELD_RESPONSE_MODES.includes(field.response_rules?.[code]))
    .map((code) => [code, field.response_rules[code]]));
  if (Object.keys(rules).length) out.response_rules = rules;
  return out;
}

export function serializeChecklistTypeItems(items, sourceItems = []) {
  const source = Array.isArray(sourceItems) ? sourceItems : [];
  const rows = Array.isArray(items) ? items : [];
  // Index fallback is only safe when the editor omitted every persisted id
  // (JSON / HMS replace). A new row at an occupied index must not inherit one.
  const restoreIdsByIndex = rows.every(
    (row) => persistedChecklistTypeItemId(row?.id) == null
  );
  return rows.map((row, index) => {
    const matchedSource = source.find(
      (candidate) =>
        persistedChecklistTypeItemId(row?.id) != null &&
        persistedChecklistTypeItemId(candidate?.id) ===
          persistedChecklistTypeItemId(row.id)
    );
    const sourceRow =
      matchedSource || (restoreIdsByIndex ? source[index] : undefined);
    const id =
      persistedChecklistTypeItemId(row?.id) ??
      persistedChecklistTypeItemId(sourceRow?.id);
    const guidance = row?.guidance || row?.description || "";
    return {
      ...(id != null ? { id } : {}),
      title: row?.title || "",
      guidance,
      description: row?.description || guidance,
      documents_required: Boolean(row?.documents_required),
      response_actions: row?.response_actions ?? null,
      input_fields: (Array.isArray(row?.input_fields) ? row.input_fields : [])
        .map(serializeChecklistTypeInputField)
        .filter(Boolean),
      row_order: row?.row_order ?? index,
    };
  });
}

export function buildChecklistTypeSavePayload(values = {}, { sourceItems } = {}) {
  const source = sourceItems || values.items || [];
  return {
    ...(values.id != null ? { id: values.id } : {}),
    title: values.title,
    description: values.description,
    active: values.active,
    default_response_actions: values.default_response_actions,
    items: serializeChecklistTypeItems(values.items, source),
  };
}

export function mergeImportedItemsWithExistingIds(
  existingItems = [],
  importedItems = [],
  mode = "replace"
) {
  if (mode === "append") {
    return [...existingItems, ...importedItems];
  }

  return (importedItems || []).map((row, index) => {
    const previous = (existingItems || [])[index];
    const id =
      persistedChecklistTypeItemId(row?.id) ??
      persistedChecklistTypeItemId(previous?.id);
    return id != null ? { ...row, id } : row;
  });
}
